import {Spinner} from "@chakra-ui/react";

export const InputSpinner = ({inProgress}: {inProgress: boolean}) =>
  inProgress ? <Spinner color="gray.500" size="sm" /> : null;
